import { useToast } from "primevue/usetoast";
import { useVideosStore } from "@/stores/videos";

// Deleting is one tap: the files wait a day in .trash, so instead of a
// confirm the toast offers to take it back. Its messages go to the group
// "undo", which App.vue renders on every page (Undo when data.javId).
export const UNDO_GROUP = "undo";

export function useDeleteVideo() {
    const toast = useToast();
    const store = useVideosStore();

    async function deleteVideo(javId: string) {
        try {
            const res = await store.trashVideo(javId);
            toast.add({
                group: UNDO_GROUP,
                severity: "warn",
                summary: `Deleted ${javId}`,
                detail: res.purge_after
                    ? `Its files are purged ${new Date(res.purge_after).toLocaleString()} unless restored`
                    : "It will not be downloaded again",
                life: 15000,
                data: { javId },
            } as Parameters<typeof toast.add>[0] & { data: { javId: string } });
            for (const e of res.errors) console.warn(`delete ${javId}: ${e}`);
            return res;
        } catch (err) {
            toast.add({ group: UNDO_GROUP, severity: "error", summary: `Deleting ${javId} failed`, detail: String(err), life: 8000 });
            throw err;
        }
    }

    async function restoreVideo(javId: string) {
        try {
            const res = await store.restoreVideo(javId);
            toast.add({
                group: UNDO_GROUP,
                severity: res.errors.length ? "warn" : "success",
                summary: `Restored ${javId}`,
                detail: res.errors.length ? res.errors.join("; ") : `${res.restored_files} file(s) back`,
                life: 6000,
            });
            return res;
        } catch (err) {
            toast.add({ group: UNDO_GROUP, severity: "error", summary: `Restoring ${javId} failed`, detail: String(err), life: 8000 });
            throw err;
        }
    }

    return { deleteVideo, restoreVideo };
}
